import { useState } from "react";
import { useSelector } from "react-redux";
import Button from "../../design/Button";
import GModal from "../../design/components/GModal";
import { Checkbox, FormControlLabel } from "@mui/material";
import {
  checkboxCheck,
  checkboxUncheck,
} from "../../../utility-functions/assetLoader";
import classes from "./ZohoDisconnectModal.module.css";

const ZohoDisconnectModal = ({
  visible,
  closeModal,
  onDisconnect,
  isDisconnecting,
}) => {
  const { canManageOrgLevelIntegrations } = useSelector(
    (state) => state?.auth?.permissions,
  );
  const [deleteForAllUsers, setDeleteForAllUsers] = useState(false);

  const handleDisconnect = () => {
    onDisconnect(deleteForAllUsers);
  };

  const handleClose = () => {
    setDeleteForAllUsers(false);
    closeModal();
  };

  return (
    <GModal
      visible={visible}
      heading="Disconnect integration"
      closeModal={handleClose}
      bottomButtons={[
        <Button
          key="cancel"
          buttonText="Cancel"
          variant="outlined"
          hierarchy="white"
          onClick={handleClose}
        />,
        <Button
          key="disconnect"
          buttonText="Disconnect"
          variant="contained"
          hierarchy="red"
          isLoading={isDisconnecting}
          onClick={handleDisconnect}
        />,
      ]}
      body={
        <div className={classes.body}>
          <p className={classes.bodyText}>
            Are you sure you want to disconnect <span>Zoho Phonebridge</span>{" "}
            from FreJun?
          </p>
          {canManageOrgLevelIntegrations && (
            <FormControlLabel
              control={
                <Checkbox
                  disableRipple
                  checkedIcon={checkboxCheck()}
                  icon={checkboxUncheck()}
                  checked={deleteForAllUsers}
                  onChange={(e) => setDeleteForAllUsers(e.target.checked)}
                />
              }
              label="Disable integration for all users"
              sx={{
                ".MuiFormControlLabel-label": {
                  fontSize:'14px',
                  lineHeight:'20px',
                  fontWeight:'400',
                  color: '#3f3f46',
                },
                
              }}
            />
          )}
        </div>
      }
      modalStyle={{ width: "440px" }}
    />
  );
};

export default ZohoDisconnectModal;
